import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';

export interface UploadFileFieldModel extends BaseFieldModel {
  defaultValue: undefined;
  type: FieldType.UploadFile;
}
export class UploadFileField extends BaseField implements UploadFileFieldModel {
  public defaultValue = undefined;
  public type: FieldType.UploadFile = FieldType.UploadFile;

  constructor(cultures: string[]) {
    super(FieldType.UploadFile, cultures);
  }
}
